import { PublicKey } from '@solana/web3.js';

/** Devnet program ID for the contracts Markets program. */
export const MORFI_OPINION_PROGRAM_ID: PublicKey = new PublicKey(
  'XuXkWAz3xRktfEjAfFDdkFksYBqFzet8JPkQxZMoRfi',
);

/**
 * Program ID for the cp-swap (Raydium CPMM fork) program used by graduated
 * markets. Its custom error codes overlap the markets program, so
 * transaction-error parsing disambiguates by this id. Source of truth:
 * `contracts/morfi-cp-swap/programs/cp-swap/src/lib.rs` declare_id!.
 */
export const CP_SWAP_PROGRAM_ID: PublicKey = new PublicKey(
  'morfijP38RdW7M9jJ4rAEpcsyXSQgHpCafN3vgvYwGC',
);

/**
 * Morfi protocol-owned cp-swap create-pool-fee receiver required by its
 * `initialize` account constraints. A WSOL token account owned (token-authority)
 * by the cp-swap admin. Source of truth:
 * `contracts/morfi-cp-swap/programs/cp-swap/src/lib.rs` create_pool_fee_reveiver::ID.
 */
export const CREATE_POOL_FEE_RECEIVER: PublicKey = new PublicKey(
  'HheDAEhcbU2K224WRWJhBf8cgvzSrdtXZjhAMb16SUm7',
);

/** SPL Token program ID (for USDC). */
export const TOKEN_PROGRAM_ID: PublicKey = new PublicKey(
  'TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA',
);

/** Token-2022 program ID (for outcome tokens). */
export const TOKEN_2022_PROGRAM_ID: PublicKey = new PublicKey(
  'TokenzQdBNbLqP5VEhdkAS6EPFLC1PHnBqCXEpPxuEb',
);

/** Associated Token Account program ID. */
export const ASSOCIATED_TOKEN_PROGRAM_ID: PublicKey = new PublicKey(
  'ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL',
);

/** Devnet USDC mint address (Morfi-controlled, mint authority: deployer wallet). */
export const DEVNET_USDC_MINT: PublicKey = new PublicKey(
  'GwMYubfhtHzP2vNcoDVRbt64T5ruHRpq5w2wCXGMNTB7',
);

/** System program ID. */
export const SYSTEM_PROGRAM_ID: PublicKey = new PublicKey('11111111111111111111111111111111');
